/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TrustCommercebillingsBilling model module.
 * @module model/TrustCommercebillingsBilling
 * @version v0.3
 */
export default class TrustCommercebillingsBilling {
  /**
   * Constructs a new <code>TrustCommercebillingsBilling</code>.
   * @alias module:model/TrustCommercebillingsBilling
   * @class
   * @param token {String} TrustCommerce transaction token
   */
  constructor(token) {
    this.token = token;
  }

  /**
   * Constructs a <code>TrustCommercebillingsBilling</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommercebillingsBilling} obj Optional instance to populate.
   * @return {module:model/TrustCommercebillingsBilling} The populated <code>TrustCommercebillingsBilling</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommercebillingsBilling();
      if (data.hasOwnProperty('token'))
        obj.token = ApiClient.convertToType(data['token'], 'String');
    }
    return obj;
  }
}

/**
 * TrustCommerce transaction token
 * @member {String} token
 */
TrustCommercebillingsBilling.prototype.token = undefined;

